import Vue from "vue";
import axios from "axios";
import moment from "moment";
import "../../filters";
import users from "../../users";
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

export default {
  name: "connectionDetails",
  components: {
    DataGridComp: require("../../customcontrols/datagrid.vue").default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      selectedTab: "general",
      selectedHistoryReading: null,
      menuVisible: true,
      scrollAmt: 200,
      ConnectionId: "",
      lang: "",
      tabs: [],
      serviceCategory: "",
      connectionStatus: "",
      connDate: null,
      statusDate: null,
      volDiscon: false,
      connType: "",
      blkPropRef: "",
      blkConnNo: "",
      flatsNo: null,
      estimConsumption: null,
      otherDetails: "",
      connectionSize: null,
      tagNo: "",
      oldKey: "",
      surveyDate: null,
      surveyRef: "",
      bookNo: "",
      walkNo: "",
      sequence: "",
      prevPropRef: "",
      permanentMessage: "",
      noAccessMessage: "",
      propCode: "",
      propDescription: "",
      gpsx: "",
      gpsy: "",
      pdop: "",
      meterTypeDataSource: [],
      meterMakeDataSource: [],
      meterSizeDataSource: [],
      meterConditionDataSource: [],
      meterWarehouseDataSource: [],
      meterType: "",
      meterTypeDisplay: "",
      meterMake: "",
      meterMakeDisplay: "",
      meterSize: "",
      meterSizeDisplay: "",
      meterCondition: "",
      meterConditionDisplay: "",
      meterSerialNo: "",
      meterTagNo: "",
      meterRef: "",
      meterDialsNo: 0,
      meterConvFactor: 0,
      meterAge: null,
      instalationDate: null,
      expiryDate: null,
      meterWarehouse: null,
      meterWarehouseDisplay: "",
      meterReading: [],
      meterReadingCols: [],
      opHistory: [],
      opHistoryCols: [],
      historyReadings: [],
      historyReadingsCols: [],
      detailChanges: [],
      detailChangesCols: [],
      statusChanges: [],
      statusChangesCols: [],

      meterReadingTotalRow: 0,
      meterReadingPageingoptions: { pageSize: 10, total: 0, page: 1 },
      opHistoryTotalRow: 0,
      opHistoryPageingoptions: { pageSize: 10, total: 0, page: 1 },
      historyReadingsTotalRow: 0,
      historyReadingsPageingoptions: { pageSize: 10, total: 0, page: 1 },
      detailChangesTotalRow: 0,
      detailChangesPageingoptions: { pageSize: 10, total: 0, page: 1 },
      statusChangesTotalRow: 0,
      statusChangesPageingoptions: { pageSize: 10, total: 0, page: 1 },

      spId: '',
      usId: '',
      usDeactivated: '',
      connectionData: {},
      subConnections: [],
    };
  },
  computed: {
    isRtl: function () {
      return this.lang == 'ar' ? true : false
    },
    selectedTabObj: function () {
      return this.tabs.filter(t => t.id == this.selectedTab)[0];
    }
  },
  watch: {
    selectedTab: function (val) {
      if (!val)
        return;

      switch (val) {
        default:
          this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrl(val);
    },
  },
  created() {
    this.ConnectionId = this.$route.params.ConnectionId;
    this.$material.locale.dateFormat = "dd/MM/yyyy";
    this.tabs = [
      {
        id: "general",
        show: true,
        ...this.enqIcons.general,
      },
      {
        id: "subConnections",
        show: false,
        ...this.enqIcons.subConnections,
      },
      {
        id: "locate",
        label: this.$t("enquiriesConnectionDetails.locate"),
        show: true,
        icon: this.enqIcons.gpsPin.icon,
      },
      {
        id: "meter",
        show: true,
        ...this.enqIcons.meter,
      },
      {
        id: "meterReading",
        label: this.$t("enquiriesConnectionDetails.meterReading"),
        show: true,
        icon: this.enqIcons.readings.icon,
      },
      {
        id: "opHistory",
        //label: this.$t("enquiriesConnectionDetails.opHistory"),
        show: true,
        ...this.enqIcons.history,
      },
      {
        id: "detailChanges",
        show: true,
        ...this.enqIcons.detailChanges,
      },
      {
        id: "statusChanges",
        label: this.$t("enquiriesConnectionDetails.statusChanges"),
        show: true,
        icon: this.enqIcons.settings.icon,
      },
    ];

    this.findDefaultTab();

    this.configMeterReadingsColumns();
    this.configOpHistoryColumns();
    this.configdetailChangesColumns();
    this.configStatusChangesColumns();
    this.configHistoryReadingsColumns();
  },
  mounted() {
    this.getConnectionDetails();
  },
  methods: {
    getConnectionDetails() {
      var parameters = {
        ConnectionId: this.ConnectionId,
        loginEmail: this.getLoginName(),
      };

      axios
        .post("/Enquiries/GetConnectionDetails", parameters)
        .then((response) => {
          if (response.status == 200) {
            this.connectionData = response.data.connection;
            this.getSubConnections();

            this.serviceCategory = response.data.connection.serviceCategory;
            this.connectionStatus = response.data.connection.connectionStatus;
            this.connDate = this.$options.filters.formatDateDDMMYYY(response.data.connection.connDate);
            this.statusDate = this.$options.filters.formatDateDDMMYYY(response.data.connection.statusDate);
            this.volDiscon = response.data.connection.volDiscon;
            this.connType = response.data.connection.connType;
            this.blkPropRef = response.data.connection.blkPropRef;
            this.blkConnNo = response.data.connection.blkConnNo;

            this.flatsNo = response.data.connection.flatsNo;
            this.estimConsumption = response.data.connection.estimConsumption;
            this.otherDetails = response.data.connection.otherDetails;
            this.connectionSize = response.data.connection.connectionSize;

            this.tagNo = response.data.connection.tagNo;
            this.oldKey = response.data.connection.oldKey;
            this.surveyDate = this.$options.filters.formatDateDDMMYYY(response.data.connection.surveyDate);
            this.surveyRef = response.data.connection.surveyRef;

            this.bookNo = response.data.connection.bookNo;
            this.walkNo = response.data.connection.walkNo;
            this.sequence = response.data.connection.sequence;
            this.prevPropRef = response.data.connection.prevPropRef;

            this.permanentMessage = response.data.connection.permanentMessage;
            this.noAccessMessage = response.data.connection.noAccessMessage;
            this.propCode = response.data.connection.propCode;
            this.propDescription = response.data.connection.propDescription;

            this.gpsx = response.data.connection.gpsx;
            this.gpsy = response.data.connection.gpsy;
            this.pdop = response.data.connection.pdop;

            this.tabs.filter((a) => a.id == "meter")[0].show = response.data.connection.showMeter;

            this.meterTypeDataSource = response.data.connection.meterTypeDataSource;
            this.meterMakeDataSource = response.data.connection.meterMakeDataSource;
            this.meterSizeDataSource = response.data.connection.meterSizeDataSource;
            this.meterConditionDataSource = response.data.connection.meterConditionDataSource;
            this.meterWarehouseDataSource = response.data.connection.meterWarehouseDataSource;

            this.meterType = response.data.connection.meterType;
            this.meterMake = response.data.connection.meterMake;
            this.meterSize = response.data.connection.meterSize;
            this.meterCondition = response.data.connection.meterCondition;

            this.meterSerialNo = response.data.connection.meterSerialNo;
            this.meterTagNo = response.data.connection.meterTagNo;
            this.meterRef = response.data.connection.meterRef;
            this.meterDialsNo = response.data.connection.meterDialsNo;
            this.meterConvFactor = response.data.connection.meterConvFactor;
            this.meterAge = response.data.connection.meterAge;
            this.instalationDate = this.$options.filters.formatDateDDMMYYY(response.data.connection.instalationDate);
            this.expiryDate = this.$options.filters.formatDateDDMMYYY(response.data.connection.connExpiryDate);
            this.meterWarehouse = response.data.connection.meterWarehouse;
            this.spId = response.data.connection.spId;
            this.usId = response.data.connection.usId;
            this.usDeactivated = response.data.connection.usDeactivated;

            this.meterTypeDisplay = this.meterTypeDataSource.filter(m => m.id == this.meterType)[0].displayString;
            this.meterMakeDisplay = this.meterMakeDataSource.filter(m => m.id == this.meterMake)[0].displayString;
            this.meterWarehouseDisplay = this.meterWarehouseDataSource.filter(m => m.id == this.meterWarehouse)[0].displayString;
            this.meterConditionDisplay = this.meterConditionDataSource.filter(m => m.id == this.meterCondition)[0].displayString;
            this.meterSizeDisplay = this.meterSizeDataSource.filter(m => m.id == this.meterSize)[0].displayString;

          }
        })
        .then((a) => {
          this.getMeterReadings();
          this.getOpHistory();
          this.getDetailsChanges();
          this.getStatusChanges();
        })
        .catch((e) => {
          return false;
        });
    },

    configMeterReadingsColumns() {
      this.meterReadingCols.push({
        dataField: "bilingDate",
        caption: this.$t("enquiriesConnectionRead.billingCycle"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYY,
      });
      this.meterReadingCols.push({
        dataField: "billCustkey",
        caption: this.$t("enquiriesConnectionRead.customer"),
      });
      this.meterReadingCols.push({
        dataField: "meterRef",
        caption: this.$t("enquiriesConnectionRead.meterRef"),
      });
      this.meterReadingCols.push({
        dataField: "crDate",
        caption: this.$t("enquiriesConnectionRead.readingDate"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYY,
      });
      this.meterReadingCols.push({
        dataField: "crReading",
        caption: this.$t("enquiriesConnectionRead.reading"),
      });
      this.meterReadingCols.push({
        dataField: "isPosted",
        caption: this.$t("enquiriesConnectionRead.posted"),
        dataType: "boolean",
      });
      this.meterReadingCols.push({
        dataField: "descr",
        caption: this.$t("enquiriesConnectionRead.discrepancy"),
      });
      this.meterReadingCols.push({
        dataField: "dadescr",
        caption: this.$t("enquiriesConnectionRead.noAccess"),
      });
      this.meterReadingCols.push({
        dataField: "dndescr",
        caption: this.$t("enquiriesConnectionRead.note"),
      });
      this.meterReadingCols.push({
        dataField: "name",
        caption: this.$t("enquiriesConnectionRead.meterReader"),
      });
      this.meterReadingCols.push({
        dataField: "serialNo",
        caption: this.$t("enquiriesConnectionRead.serialNo"),
      });
      this.meterReadingCols.push({
        dataField: "serialNoOld",
        caption: this.$t("enquiriesConnectionRead.serialNoOld"),
      });
      this.meterReadingCols.push({
        dataField: "xGps",
        caption: this.$t("enquiriesConnectionRead.gpsX"),
      });
      this.meterReadingCols.push({
        dataField: "yGps",
        caption: this.$t("enquiriesConnectionRead.gpsY"),
      });
      this.meterReadingCols.push({
        dataField: "cGps",
        caption: this.$t("enquiriesConnectionRead.gpsC"),
      });
      this.meterReadingCols.push({
        dataField: "makeDescribe",
        caption: this.$t("enquiriesConnectionRead.make"),
      });
      this.meterReadingCols.push({
        dataField: "makeOldDescribe",
        caption: this.$t("enquiriesConnectionRead.makeOld"),
      });
      this.meterReadingCols.push({
        dataField: "sizeDescribe",
        caption: this.$t("enquiriesConnectionRead.size"),
      });
      this.meterReadingCols.push({
        dataField: "sizeOldDescribe",
        caption: this.$t("enquiriesConnectionRead.sizeOld"),
      });
      this.meterReadingCols.push({
        dataField: "noDials",
        caption: this.$t("enquiriesConnectionRead.noOfDials"),
      });
      this.meterReadingCols.push({
        dataField: "noDialsOld",
        caption: this.$t("enquiriesConnectionRead.noOfDialsOld"),
      });
      this.meterReadingCols.push({
        dataField: "locDescribe",
        caption: this.$t("enquiriesConnectionRead.location"),
      });
      this.meterReadingCols.push({
        dataField: "locDescribeOld",
        caption: this.$t("enquiriesConnectionRead.locationOld"),
      });
      this.meterReadingCols.push({
        dataField: "convFctr",
        caption: this.$t("enquiriesConnectionRead.convFactor"),
      });
      this.meterReadingCols.push({
        dataField: "convFctrOld",
        caption: this.$t("enquiriesConnectionRead.convFactorOld"),
      });
      this.meterReadingCols.push({
        dataField: "condDescribe",
        caption: this.$t("enquiriesConnectionRead.condition"),
      });
      this.meterReadingCols.push({
        dataField: "condDescribeOld",
        caption: this.$t("enquiriesConnectionRead.conditionOld"),
      });
      this.meterReadingCols.push({
        dataField: "opStatus",
        caption: this.$t("enquiriesConnectionRead.status"),
      });
      this.meterReadingCols.push({
        dataField: "opStatusOld",
        caption: this.$t("enquiriesConnectionRead.statusOld"),
      });
    },
    getMeterReadings() {
      var parameters = {
        ConnectionId: this.ConnectionId,
        Options: this.meterReadingPageingoptions,
      };

      axios
        .post("/Enquiries/getMeterReading", parameters)
        .then((response) => {
          if (response.status == 200) {
            this.meterReading = response.data.items;

            this.meterReadingTotalRow = response.data.itemsCount;
          }
        })
        .catch((e) => {
          return false;
        });
    },
    meterReadingPageChange(pInfo) {
      this.meterReadingPageingoptions.page = pInfo.pageNumber;
      this.meterReadingPageingoptions.pageSize = pInfo.pageSize;
      this.getMeterReadings();
    },

    configOpHistoryColumns() {
      this.opHistoryCols.push({
        dataField: "meterRef",
        caption: this.$t("enquiriesConnectionOpHistory.meterRef"),
      });
      this.opHistoryCols.push({
        dataField: "installDate",
        caption: this.$t("enquiriesConnectionOpHistory.installationDate"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYY,
      });
      this.opHistoryCols.push({
        dataField: "removalDate",
        caption: this.$t("enquiriesConnectionOpHistory.removalDate"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYY,
      });
    },
    getOpHistory() {
      var parameters = {
        ConnectionId: this.ConnectionId,
        Options: this.meterReadingPageingoptions,
      };

      axios
        .post("/Enquiries/getConnectionOpHistory", parameters)
        .then((response) => {
          if (response.status == 200) {
            this.opHistory = response.data.items;

            this.opHistoryTotalRow = response.data.itemsCount;
          }
        })
        .catch((e) => {
          return false;
        });
    },
    opHistoryPageChange(pInfo) {
      this.opHistoryPageingoptions.page = pInfo.pageNumber;
      this.opHistoryPageingoptions.pageSize = pInfo.pageSize;
      this.getOpHistory();
    },

    configHistoryReadingsColumns() {
      this.historyReadingsCols.length = 0;

      this.historyReadingsCols.push({ dataField: 'readingNoAbs', caption: this.$t('enquiriesAccount.no') });
      this.historyReadingsCols.push({ dataField: 'meterRef', caption: this.$t('customReadings.MeterRef') });
      this.historyReadingsCols.push({ dataField: 'rdgDate', caption: this.$t('enquiriesAccount.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.historyReadingsCols.push({ dataField: 'noOfDays', caption: this.$t('enquiriesAccount.noOfDays') });
      this.historyReadingsCols.push({ dataField: 'reading', caption: this.$t('enquiriesAccount.reading') });
      this.historyReadingsCols.push({ dataField: 'calculatedConsumption', caption: this.$t('enquiriesAccount.calculatedConsumption') });
      this.historyReadingsCols.push({ dataField: 'modifiedConsumption', caption: this.$t('enquiriesAccount.modifiedConsumption') });
      this.historyReadingsCols.push({ dataField: 'diffFromMainConsumption', caption: this.$t('enquiriesAccount.diffFromMainConsumption') });
      this.historyReadingsCols.push({ dataField: 'consumption', caption: this.$t('enquiriesAccount.totalConsumption') });
      this.historyReadingsCols.push({ dataField: 'flow', caption: this.$t('enquiriesAccount.flow') });
      this.historyReadingsCols.push({ dataField: 'clockOver', caption: this.$t('enquiriesAccount.clockOver') });
      this.historyReadingsCols.push({ dataField: 'isCancelled', caption: this.$t('enquiriesAccount.cancelled') });
      this.historyReadingsCols.push({ dataField: 'typeDescription', caption: this.$t('enquiriesAccount.type') });
      this.historyReadingsCols.push({ dataField: 'reasonDescription', caption: this.$t('enquiriesAccount.reason') });
      this.historyReadingsCols.push({ dataField: 'methodDescription', caption: this.$t('enquiriesAccount.readingMethod') });
      this.historyReadingsCols.push({ dataField: 'noteCode', caption: this.$t('enquiriesAccount.note') });
      this.historyReadingsCols.push({ dataField: 'accessCode', caption: this.$t('enquiriesAccount.access') });
      this.historyReadingsCols.push({ dataField: 'comment', caption: this.$t('enquiriesAccount.comment') });
      this.historyReadingsCols.push({ dataField: 'isInvoiced', caption: this.$t('enquiriesAccount.billed') });
      this.historyReadingsCols.push({ dataField: 'invoiceDate', caption: this.$t('enquiriesAccount.billingDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
    },
    getHistoryReadings() {
      var parameters = {
        ConnectionId: this.ConnectionId,
        Options: this.meterReadingPageingoptions,
        MeterId: this.selectedHistoryReading.meterId,
        LoginEmail: this.getLoginName(),
      }

      axios
        .post("/Enquiries/getMeterConnectionReadings", parameters)
        .then((response) => {
          if (response.status == 200) {
            if (response.data.items && response.data.items.length > 0) {
              response.data.items.forEach(i => {
                i['readingNoAbs'] = Math.abs(i.readingNo);
                i.flow = this.$options.filters.twoDecimals(i.flow, true);
              });
            }

            this.historyReadings = response.data.items;
            this.historyReadingsTotalRow = response.data.itemsCount;
          }
        })
        .catch((e) => {
          return false;
        });
    },
    historyReadingsPageChange(pInfo) {
      this.historyReadingsPageingoptions.page = pInfo.pageNumber;
      this.historyReadingsPageingoptions.pageSize = pInfo.pageSize;
      this.getHistoryReadings();
    },
    showHistoryReadingDetails(event) {
      this.selectedHistoryReading = event.data;
      this.getHistoryReadings();
      //console.log("event", event)
    },

    configdetailChangesColumns() {
      this.detailChangesCols.push({
        dataField: "field",
        caption: this.$t("enquiriesPropertyDetailChanges.property"),
      });
      this.detailChangesCols.push({
        dataField: "originalValue",
        caption: this.$t("enquiriesPropertyDetailChanges.originalValue"),
      });
      this.detailChangesCols.push({
        dataField: "newValue",
        caption: this.$t("enquiriesPropertyDetailChanges.newValue"),
      });
      this.detailChangesCols.push({
        dataField: "sourceId",
        caption: this.$t("enquiriesPropertyDetailChanges.applicationNo"),
      });
      this.detailChangesCols.push({
        dataField: "stampUser",
        caption: this.$t("enquiriesPropertyDetailChanges.stampUser"),
      });
      this.detailChangesCols.push({
        dataField: "stampDateTime",
        caption: this.$t("enquiriesPropertyDetailChanges.stampDateTime"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYYYHHmm,
      });
    },
    getDetailsChanges() {
      var parameters = {
        ConnectionId: this.ConnectionId,
        Options: this.meterReadingPageingoptions,
      };

      axios
        .post("/Enquiries/getConnectionDetailsChanged", parameters)
        .then((response) => {
          if (response.status == 200) {
            this.detailChanges = response.data.items;

            this.detailChangesTotalRow = response.data.itemsCount;
          }
        })
        .catch((e) => {
          return false;
        });
    },
    detailChangesPageChange(pInfo) {
      this.detailChangesPageingoptions.page = pInfo.pageNumber;
      this.detailChangesPageingoptions.pageSize = pInfo.pageSize;
      this.getDetailsChanges();
    },

    configStatusChangesColumns() {
      this.statusChangesCols.push({
        dataField: "custkey",
        caption: this.$t("enquiriesConnectionStatusChanges.account"),
      });
      this.statusChangesCols.push({
        dataField: "accountName",
        caption: this.$t("enquiriesConnectionStatusChanges.name"),
      });
      this.statusChangesCols.push({
        dataField: "date",
        caption: this.$t("enquiriesConnectionStatusChanges.date"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYY,
      });
      this.statusChangesCols.push({
        dataField: "meter",
        caption: this.$t("enquiriesConnectionStatusChanges.meter"),
      });
      this.statusChangesCols.push({
        dataField: "reading",
        caption: this.$t("enquiriesConnectionStatusChanges.reading"),
      });
      this.statusChangesCols.push({
        dataField: "disconnection",
        caption: this.$t("enquiriesConnectionStatusChanges.discon"),
        dataType: "boolean",
      });
      this.statusChangesCols.push({
        dataField: "reconnecton",
        caption: this.$t("enquiriesConnectionStatusChanges.recon"),
        dataType: "boolean",
      });
      this.statusChangesCols.push({
        dataField: "balance",
        caption: this.$t("enquiriesConnectionStatusChanges.amountDue"),
      });
      this.statusChangesCols.push({
        dataField: "applicationId",
        caption: this.$t("enquiriesConnectionStatusChanges.applicationNo"),
      });
      this.statusChangesCols.push({
        dataField: "dmCaseId",
        caption: this.$t("enquiriesConnectionStatusChanges.dmCase"),
      });
    },
    getStatusChanges() {
      var parameters = {
        ConnectionId: this.ConnectionId,
        loginEmail: this.getLoginName(),
        Options: this.meterReadingPageingoptions,
      };

      axios
        .post("/Enquiries/getConnectionStatusChanges", parameters)
        .then((response) => {
          if (response.status == 200) {
            this.statusChanges = response.data.items;

            this.statusChangesTotalRow = response.data.itemsCount;
          }
        })
        .catch((e) => {
          return false;
        });
    },
    statusChangesPageChange(pInfo) {
      this.statusChangesPageingoptions.page = pInfo.pageNumber;
      this.statusChangesPageingoptions.pageSize = pInfo.pageSize;
      this.getStatusChanges();
    },
    //openMainConnectionDetails() {
    //  if (!this.connectionData.blkConnectionId) false;

    //  let routeData = this.$router.resolve({
    //    name: "connectionDetails",
    //    params: { ConnectionId: this.connectionData.blkConnectionId },
    //  });
    //  window.open(routeData.href, "_blank");
    //},

    getSubConnections() {
      if (!this.connectionData.connectionId) return;

      axios
        .get(
          "/Enquiries/getSubConnections?connId=" +
            this.connectionData.connectionId
        )
        .then((response) => {
          if (response.data.data.status == 0) {
            this.subConnections = response.data.items;

            if (this.subConnections.length > 0) {
              this.tabs.filter((a) => a.id == "subConnections")[0].show = true;
            }
          } else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch((e) => {
          this.$alertMsg(e.data.text);
          return false;
        });
    },
    viewSubConnDetails(id) {
      let routeData = this.$router.resolve({
        name: "connectionDetails",
        params: { ConnectionId: id },
      });
      window.open(routeData.href, "_blank");
    },

    openMap() {
      if (this.gpsy && this.gpsx)
        window.open(`https://maps.google.com/?q=${this.gpsy},${this.gpsy}`);
    },
  },
};
